import { createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { ROUTES } from './_routes';

export const createRouter = () => {
  return createBrowserRouter(createRoutesFromElements(ROUTES));
};
